<template>
	<ion-page>
		<ion-header :translucent="true">
			<ion-toolbar>
				<ion-buttons slot="start">
					<ion-menu-button color="primary"></ion-menu-button>
				</ion-buttons>
				<ion-title>Create Ghat</ion-title>
			</ion-toolbar>
		</ion-header>

		<ion-content :fullscreen="true">
			<div id="container">
				<ion-item>
					<ion-label position="floating">Ghat Name: </ion-label>
					<ion-input mode="ios" v-model="postData['ghat_name']"></ion-input>
				</ion-item>
				<ion-item v-show="ghatImage.length > 0">
					<div v-for="(image,j) of ghatImage" :key="j" class="ion-text-center" style="width: 100%; margin: 10px; position:relative">
						<ion-icon 
						:ios="closeOutline" 
						:md="close" 
						style="position: absolute;right: 0;top: 0;height: 20px;width: 20px;background: #fff;box-shadow: 0 0 5px #000;border-radius: 50%;padding: 5px;"
						@click="removeGhatImage(j)"></ion-icon>
						<img v-show="image!=null" :src="image" style="max-width:100%;max-height:200px;">
					</div>
				</ion-item>
				<ion-item>
					<ion-button @click="takePicture('ghatPhoto')" color="secondary">Add Ghat Photo <small>(Minimum 3)</small></ion-button>
				</ion-item>

				<ion-item>
					<ion-label position="floating">Unloading Method: </ion-label>
					<ion-input mode="ios" v-model="postData['unloading_method']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-text>
						<h5>Dimention:</h5>
					</ion-text>
				</ion-item>
				<ion-item>
					<ion-label position="floating">River Face(In Feet): </ion-label>
					<ion-input mode="ios" v-model="postData['dimention']['river_face']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Draft(In Feet): </ion-label>
					<ion-input mode="ios" v-model="postData['dimention']['draft']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Length(In Feet): </ion-label>
					<ion-input mode="ios" v-model="postData['dimention']['length']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Width(In Feet): </ion-label>
					<ion-input mode="ios" v-model="postData['dimention']['width']"></ion-input>
				</ion-item>

				<ion-item>
					<ion-text>
						<h5>Unloading Capacity:</h5>
					</ion-text>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Sand(In CFT): </ion-label>
					<ion-input mode="ios" v-model="postData['unloading_capacity']['sand']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Fertilizer(In Bag): </ion-label>
					<ion-input mode="ios" v-model="postData['unloading_capacity']['fertilizer']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Stone(In MT): </ion-label>
					<ion-input mode="ios" v-model="postData['unloading_capacity']['stone']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Coal(In MT): </ion-label>
					<ion-input mode="ios" v-model="postData['unloading_capacity']['coal']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Cement(In Bag): </ion-label>
					<ion-input mode="ios" v-model="postData['unloading_capacity']['cement']"></ion-input>
				</ion-item>

				<ion-item>
					<ion-label position="floating">Dumping Type: </ion-label>
					<ion-select mode="ios" interface="action-sheet" v-model="postData['dumping_type']">
						<ion-select-option value="Open">Open</ion-select-option>
						<ion-select-option value="Shed">Shed</ion-select-option>
					</ion-select>
				</ion-item>

				<ion-item>
					<ion-text>
						<h5>Dumping Capacity:</h5>
					</ion-text>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Sand(In CFT): </ion-label>
					<ion-input mode="ios" v-model="postData['dumping_capacity']['sand']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Fertilizer(In Bag): </ion-label>
					<ion-input mode="ios" v-model="postData['dumping_capacity']['fertilizer']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Stone(In MT): </ion-label>
					<ion-input mode="ios" v-model="postData['dumping_capacity']['stone']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Coal(In MT): </ion-label>
					<ion-input mode="ios" v-model="postData['dumping_capacity']['coal']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Cement(In Bag): </ion-label>
					<ion-input mode="ios" v-model="postData['dumping_capacity']['cement']"></ion-input>
				</ion-item>

				
				<ion-item>
					<ion-label position="floating">Ghat Owner Name:</ion-label>
					<ion-input mode="ios" v-model="postData['ghat_owner_name']"></ion-input>
				</ion-item>
				<div v-for="(ex,j) of postData['ghat_owner_mobile']" :key="j">
					<ion-item>
						<ion-text>
							<h5>Mobile:</h5>
						</ion-text>
						<ion-button color="danger" @click="removeOwnerMobile(j)" v-if="j>0">
							Remove
						</ion-button>
					</ion-item>

					<ion-item>
						<ion-label position="floating">Ghat Owner Mobile</ion-label>
						<ion-input mode="ios" v-model="postData['ghat_owner_mobile'][j]['mobile']" type="tel"></ion-input>
					</ion-item>
				</div>
				<ion-item>
					<ion-button @click="addMoreOwnerMobile()" color="secondary">Add More Mobile</ion-button>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Ghat Owner Address</ion-label>
					<ion-input mode="ios" type="text" v-model="postData['ghat_owner_address']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Ghat Owner NID</ion-label>
					<ion-input mode="ios" type="tel" v-model="postData['ghat_owner_nid']"></ion-input>
				</ion-item>

				<ion-item v-show="nidImage!=null">
					<div class="ion-text-center" style="width: 100%; margin: 10px;">
						<img v-show="nidImage!=null" :src="nidImage" style="max-width:100%;max-height:200px;">
					</div>
				</ion-item>

				<ion-item>
					<ion-button @click="takePicture('nid')" color="secondary">Add Nid Photo</ion-button>
				</ion-item>

				<ion-item>
					<ion-label position="floating">Info Provided By: </ion-label>
					<ion-select mode="ios" interface="action-sheet" v-model="postData['info_provided_by']">
						<ion-select-option v-for="(data,i) of ['Owner','Manager','Caretaker','Others']" :key="i" :value="data">{{data}}</ion-select-option>
					</ion-select>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Info Provider Name</ion-label>
					<ion-input mode="ios" type="text" v-model="postData['info_provider_name']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Info Provider Mobile</ion-label>
					<ion-input mode="ios" type="tel" v-model="postData['info_provider_mobile']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Number Of Unloading Point</ion-label>
					<ion-input mode="ios" type="tel" v-model="postData['number_of_unloading_point']"></ion-input>
				</ion-item>
				<ion-item>
					<ion-label position="floating">Weight Scale Within 1 km </ion-label>
					<ion-select mode="ios" interface="action-sheet" v-model="postData['weight_scale_within_1_km']">
						<ion-select-option value="Yes">Yes</ion-select-option>
						<ion-select-option value="No">No</ion-select-option>
					</ion-select>
				</ion-item>
				
				<ion-item>
					<ion-label position="floating">Ghat Location</ion-label>
					<ion-input mode="ios" v-model="location" readonly="true" disabled></ion-input>
				</ion-item>
				<ion-item>
					<ion-button @click="getGhatLocation()" color="secondary">Add Ghat Location</ion-button>
				</ion-item>

				<ion-button expand="block" @click="save()" color="primary">Save</ion-button>
			</div>
		</ion-content>
	</ion-page>
</template>

<script>
	import {
		IonButtons,
		IonButton,
		IonContent,
		IonHeader,
		IonMenuButton,
		IonPage,
		IonTitle,
		IonToolbar,
		IonInput,
		IonItem,
		IonLabel,
		IonSelect,
		IonSelectOption,
		IonText,
		IonSegment,
		IonSegmentButton,
		alertController,
		IonImg,
		IonIcon,
	} from '@ionic/vue';
	import Loading from '../Loading';
	import {
		Geolocation
	} from '@capacitor/geolocation';
	import {
		Camera,
		CameraResultType,
		CameraSource
	} from "@capacitor/camera";
	import {
    close,
    closeOutline,
  } from 'ionicons/icons';
	export default {
		name: 'Create Service Requisition',
		components: {
			IonButtons,
			IonButton,
			IonContent,
			IonHeader,
			IonMenuButton,
			IonPage,
			IonTitle,
			IonToolbar,
			IonInput,
			IonItem,
			IonLabel,
			IonSelect,
			IonSelectOption,
			IonText,
			IonIcon,
		},
		data() {
			return {
				ghatImage: [],
				nidImage: null,
				location: null,
				postData: {
					'ghat_name': null,
					'ghat_picture': [],
					'unloading_method': null,
					'dimention': {
						'river_face_unit':'Feet',
						'river_face':null,
						'draft_unit':'Feet',
						'draft':null,
						'length_unit':'Feet',
						'length':null,
						'width_unit':'Feet',
						'width':null,
					},
					'unloading_capacity': {
						'sand_unit':'CFT',
						'sand':null,
						'fertilizer_unit':'Bag',
						'fertilizer':null,
						'stone_unit':'MT',
						'stone':null,
						'coal_unit':'MT',
						'coal':null,
						'cement_unit':'Bag',
						'cement':null,
					},
					'dumping_type': null,
					'dumping_capacity': {
						'sand_unit':'CFT',
						'sand':null,
						'fertilizer_unit':'Bag',
						'fertilizer':null,
						'stone_unit':'MT',
						'stone':null,
						'coal_unit':'MT',
						'coal':null,
						'cement_unit':'Bag',
						'cement':null,
					},
					'ghat_owner_name': null,
					'ghat_owner_mobile': [{
						mobile: null
					}],
					'ghat_owner_address': null,
					'ghat_owner_nid': null,
					'ghat_owner_nid_picture': null,
					'info_provided_by': null,
					'info_provider_name': null,
					'info_provider_mobile': null,
					'number_of_unloading_point': null,
					'weight_scale_within_1_km': null,
					'ghat': {
						lat: null,
						lng: null,
					},
				},
				closeOutline,
				close
			}
		},
		methods: {
			clearDateTime(event) {
				event.target.value = '';
			},
			async presentResponseAlert(type, message) {
				const alert = await alertController
					.create({
						header: type + '!',
						// subHeader: 'Subtitle',
						message: message,
						buttons: ['OK'],
					});
				await alert.present();

			},
			async save() {

				const requireds = [
					'ghat_name',
					'unloading_method',
					'dumping_type',
					'ghat_owner_name',
					'info_provided_by',
					'info_provider_name',
					'info_provider_mobile',
					'number_of_unloading_point',
					'weight_scale_within_1_km',
				];
				
				for (const required of requireds) {
					if (Array.isArray(required) != true && this.postData[required] == '' || this.postData[required] == null) {
						let name = required;
						name = name.replace('_id', '');
						name = name.replace('_', ' ');
						this.presentAlert(name);
						return;
					}
				}

				requireds['dimention'] = [
					'river_face',
					'draft',
					'length',
					'width',
				];
				for(const required of requireds['dimention']){
					if (Array.isArray(required) != true) {
						if(this.postData['dimention'][required] == '' || this.postData['dimention'][required] == null){
							let name = required;
							name = name.replace('_id', '');
							name = name.replace('_', ' ');
							this.presentAlert('Dimention '+name);
							return;
						}
						
					}
				}
				requireds['unloading_capacity'] = [
					'sand',
					'fertilizer',
					'stone',
					'coal',
					'cement',
				];
				for(const required of requireds['unloading_capacity']){
					if (Array.isArray(required) != true) {
						if(this.postData['unloading_capacity'][required] == '' || this.postData['unloading_capacity'][required] == null){
							let name = required;
							name = name.replace('_id', '');
							name = name.replace('_', ' ');
							this.presentAlert('Unloading capacity '+name);
							return;
						}
						
					}
				}

				requireds['dumping_capacity'] = [
					'sand',
					'fertilizer',
					'stone',
					'coal',
					'cement',
				];
				for(const required of requireds['dumping_capacity']){
					if (Array.isArray(required) != true) {
						if(this.postData['dumping_capacity'][required] == '' || this.postData['dumping_capacity'][required] == null){
							let name = required;
							name = name.replace('_id', '');
							name = name.replace('_', ' ');
							this.presentAlert('Dumping capacity '+name);
							return;
						}
						
					}
				}

				if ((this.postData['ghat']['lat'] == '' || this.postData['ghat']['lat'] == null) || (this.postData[
						'ghat']['lng'] == '' || this.postData['ghat']['lng'] == null)) {
					this.presentAlert('Location');
					return;
				}
				if (this.postData['ghat_owner_mobile'].length > 0) {
					for (const i in this.postData['ghat_owner_mobile']) {
						if (this.postData['ghat_owner_mobile'][i]['mobile'] == '' || this.postData['ghat_owner_mobile'][i][
								'mobile'
							] == null) {
							this.presentAlert('Ghat owner mobile');
							return;
						} else if (this.postData['ghat_owner_mobile'][i]['mobile'].length != 11) {
							this.presentAlert('Owner Mobile number must be in 11 characters.', true);
							return;
						} else if (["013", "014", "015", "016", "017", "018", "019"].includes(this.postData[
								'ghat_owner_mobile'][i]['mobile'].substring(0, 3)) == false) {
							this.presentAlert('Incorrect owner mobile number format.', true);
							return;
						} else if (!Number(this.postData['ghat_owner_mobile'][i]['mobile'])) {
							this.presentAlert('Incorrect owner mobile number.', true);
							return;
						}
					}
				}

				if (this.postData['info_provider_mobile'] == '' || this.postData['info_provider_mobile'] == null) {
					this.presentAlert('Info provider mobile');
					return;
				} else if (this.postData['info_provider_mobile'].length != 11) {
					this.presentAlert('Info provider Mobile number must be in 11 characters.', true);
					return;
				} else if (["013", "014", "015", "016", "017", "018", "019"].includes(this.postData[
						'info_provider_mobile'].substring(0, 3)) == false) {
					this.presentAlert('Incorrect info provider mobile number format.', true);
					return;
				} else if (!Number(this.postData['info_provider_mobile'])) {
					this.presentAlert('Incorrect info provider mobile number.', true);
					return;
				}

				if(this.postData["ghat_picture"].length <= 2){
					this.presentAlert('Ghat picture is required. Minimum 3', true);
					return;
				}
				
				const data = this.postData;
				if (this.postData['ghat_owner_mobile'].length > 0) {
					const temp = [];
					for (const i in this.postData['ghat_owner_mobile']) {
						temp.push(this.postData['ghat_owner_mobile'][i]['mobile']);
					}
					data['ghat_owner_mobile'].length = 0;
					data['ghatOwnerMobile'] = temp;
				}
				
				data['lat'] = this.postData['ghat']['lat'];
				data['lng'] = this.postData['ghat']['lng'];
				data['username'] = window.localStorage.username,
				data['password'] = window.localStorage.password,
				this.$http.post('Ghat/Create', data).then(response => {
					console.log(response);
					if(response.data.status){
						this.presentResponseAlert('success',response.data.message);
						this.ghatImage= [];
						this.postData["ghat_picture"] = [];
						this.nidImage= null;
						this.postData["ghat_owner_nid_picture"] = null;
						this.location= null;

						this.postData['ghat_name']=null;
						this.postData['unloading_method']=null;
						this.postData['dimention']['river_face']=null;
						this.postData['dimention']['draft']=null;
						this.postData['dimention']['length']=null;
						this.postData['dimention']['width']=null;
						this.postData['unloading_capacity']['sand']=null;
						this.postData['unloading_capacity']['fertilizer']=null;
						this.postData['unloading_capacity']['stone']=null;
						this.postData['unloading_capacity']['coal']=null;
						this.postData['unloading_capacity']['cement']=null;
						this.postData['dumping_type']=null;
						this.postData['dumping_capacity']['sand']=null;
						this.postData['dumping_capacity']['fertilizer']=null;
						this.postData['dumping_capacity']['stone']=null;
						this.postData['dumping_capacity']['coal']=null;
						this.postData['dumping_capacity']['cement']=null;

						this.postData['ghat_owner_name']=null;
						this.postData['ghat_owner_mobile']=[{
								mobile: null
							}];

						this.postData['ghat_owner_address']=null;
						this.postData['ghat_owner_nid']=null;
						this.postData['info_provided_by']=null;
						this.postData['info_provider_name']=null;
						this.postData['info_provider_mobile']=null;
						this.postData['number_of_unloading_point']=null;
						this.postData['weight_scale_within_1_km']=null;
						
						this.postData['ghat'] = [{
									lat:null,
									lng:null,
								}];
					}
					// console.log(response);
				}).catch(async (error)=> {
					console.log(error);
				});

				
			},
			async presentAlert(message, fullText = false) {
				const alert = await alertController
					.create({
						header: 'Alert!',
						// subHeader: 'Subtitle',
						message: fullText ? message : message + " is required",
						buttons: ['OK'],
					});
				await alert.present();

			},

			addMoreOwnerMobile() {
				this.postData['ghat_owner_mobile'].push({
					mobile: null
				});
			},
			removeOwnerMobile(e) {
				const ex = [];
				for (let i = 0; i < this.postData['ghat_owner_mobile'].length; i++) {
					if (i != e) {
						ex.push(this.postData['ghat_owner_mobile'][i]);
					}
				}
				this.postData['ghat_owner_mobile'] = ex;
			},
			addMoreOperatorMobile() {
				this.postData['operator_mobile'].push({
					mobile: null
				});
			},
			removeOperatorMobile(e) {
				const ex = [];
				for (let i = 0; i < this.postData['operator_mobile'].length; i++) {
					if (i != e) {
						ex.push(this.postData['operator_mobile'][i]);
					}
				}
				this.postData['operator_mobile'] = ex;
			},
			async takePicture(e) {

				const image = await Camera.getPhoto({
					quality: 90,
					height: 720,
					allowEditing: false,
					takePicture: true,
					source: CameraSource.Camera,
					resultType: CameraResultType.Base64,
				});
				if (image) {
					const img = "data:image/jpeg;base64," + image.base64String;
					if (e == 'nid') {
						this.postData["ghat_owner_nid_picture"] = image.base64String;
						this.nidImage = img;
					}  else if (e == 'ghatPhoto') {
						this.postData["ghat_picture"].push(image.base64String);
						this.ghatImage.push(img);
					}
				}
			},

			removeGhatImage(e) {
				this.ghatImage.splice(e,1);
				this.postData["ghat_picture"].splice(e,1);
			},
			async getGhatLocation() {
				const coordinates = await Geolocation.getCurrentPosition();
				this.postData['ghat']['lat'] = coordinates.coords.latitude;
				this.postData['ghat']['lng'] = coordinates.coords.longitude;
				this.location = 'Lat=' + coordinates.coords.latitude + ', Lng=' + coordinates.coords.longitude;
			}
		},


	}
</script>

<style scoped>
	#container {
		text-align: center;
		position: absolute;
		left: 0;
		right: 0;
		/* top: 50%; */
		/* transform: translateY(-50%); */
	}

	#container strong {
		font-size: 20px;
		line-height: 26px;
	}

	#container p {
		font-size: 16px;
		line-height: 22px;
		color: #8c8c8c;
		margin: 0;
	}

	#container a {
		text-decoration: none;
	}

	.p-dropdown {
		width: 100%;
		color: #000;
	}

	.required {
		color: rgb(233, 0, 0)
	}
</style>